module.exports = __webpack_public_path__ + "img/logo-search.481af944.png";